var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.addEmailNoticeShow,
          expression: "addEmailNoticeShow"
        }
      ],
      ref: "addEmailNotice",
      staticClass: "popup",
      attrs: { id: "addEmailNotice" }
    },
    [
      _c(
        "div",
        { staticClass: "content", attrs: { id: "addEmailNoticeBox" } },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.$t("language.popup.remoteTaskPopup.addLinkTask")) +
                "\n\t\t\t\t"
            ),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.closePopup()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "emial-notice-content" },
            [
              _c("tabEmail", { ref: "tabEmail" }),
              _vm._v(" "),
              _c("div", { staticClass: "emial-notice-footer" }, [
                _c(
                  "button",
                  {
                    staticStyle: { float: "right" },
                    on: {
                      click: function($event) {
                        return _vm.saveSendEmail()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.common.save")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "white-button",
                    staticStyle: { float: "right", "margin-right": "10px" },
                    on: {
                      click: function($event) {
                        return _vm.closePopup()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
                )
              ])
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8b8f96c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8b8f96c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/remote_task_popups/add_email_notice_popup.vue
// module id = null
// module chunks = 